function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("polyline", {
  points: "14 2 14 8 20 8"
});

var _ref3 =
/*#__PURE__*/
React.createElement("line", {
  x1: 16,
  y1: 13,
  x2: 8,
  y2: 13
});

var _ref4 =
/*#__PURE__*/
React.createElement("line", {
  x1: 16,
  y1: 17,
  x2: 8,
  y2: 17
});

var _ref5 =
/*#__PURE__*/
React.createElement("polyline", {
  points: "10 9 9 9 8 9"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-file-text"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default __webpack_public_path__ + "static/media/file-text.09f0201e.svg";
export { SvgComponent as ReactComponent };